export default (cart, originalDomain, suggestedDomain) => ({
	event: 'emailTypoClick',
	emailTypoInfo: `${originalDomain} | ${suggestedDomain}`,
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
